<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6" offset-lg="3">
        <b-card class="chat">
          <div
            slot="header"
            style="display:flex; justify-content: space-between;"
          >
            <HeaderTitle title="Direct Messages to FNS Team"></HeaderTitle>
          </div>
          <Chat v-if="propsReady" :cityId="locationParam" :isDirect="1"></Chat>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Chat from "../../../components/shared/Chat";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import router from "../../../router";
import { isUserLoggedIn } from "../../../utils/Utils";

export default {
  name: "Inbox",
  components: {
    Chat,
    HeaderTitle
  },
  data: function() {
    return {
      propsReady: false,
      locationParam: "",
      cityParam: ""
    };
  },

  methods: {
    makeSeen() {
      let params = {};
      params = {
        client: this.locationParam
      };
      this.$http
        .get("api/inbox/makeSeen.php", {
          params
        })
        .then(
          () => {},
          err => {
            console.log(err);
          }
        );
    }
  },

  mounted() {
    isUserLoggedIn(router);
    this.locationParam = localStorage.getItem("user");

    this.propsReady = true;
    this.makeSeen();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
</style>
